import { render, staticRenderFns } from "./Tarieven.vue?vue&type=template&id=58d23009&scoped=true&"
import script from "./Tarieven.vue?vue&type=script&lang=js&"
export * from "./Tarieven.vue?vue&type=script&lang=js&"
import style0 from "./Tarieven.vue?vue&type=style&index=0&id=58d23009&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d23009",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VContainer,VIcon,VRow,VSimpleTable})
